// The video editor's layers strings (components/Editor), under t('editor.rve.layers.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  common: {
    volume: "الصوت",
    mute: "اكتم الصوت",
    unmute: "شغّل الصوت",
  },
  tabs: {
    settings: "الإعدادات",
    style: "الستايل",
    allCount: "الكل ({n})",
  },
  style: {
    appearance: "الشكل",
    fit: "طريقة العرض",
    fitCover: "املا الإطار",
    fitContain: "جوّه الإطار",
    fitFill: "مطّ",
    borderRadius: "تدوير الحواف",
    brightness: "الإضاءة",
    padding: "الهامش",
    paddingBackground: "خلفية الهامش",
    clear: "امسح",
  },
  filter: {
    preset: "فلتر جاهز",
    custom: "مخصص",
    presetPreview: "معاينة {name}",
  },
  filterPresets: {
    none: "بدون",
    retro: "ريترو",
    vintage: "فينتدج",
    wesAnderson: "ويس أندرسون",
    noir: "فيلم نوار",
    polaroid: "بولارويد",
    cinematic: "سينمائي",
    cool: "بارد",
    warm: "دافي",
    expired: "فيلم قديم",
    kodak: "كوداك",
    super8: "سوبر 8",
  },
  animation: {
    title: "الأنيميشن",
    enter: "أنيميشن الدخول",
    exit: "أنيميشن الخروج",
  },
  animations: {
    none: "بدون",
    fade: "تلاشي",
    slideRight: "انزلاق",
    scale: "تكبير",
    bounce: "نطّة",
    flipX: "قلب",
    zoomBlur: "زووم",
    slideUp: "انزلاق",
    snapRotate: "لفّة سريعة",
    glitch: "جليتش",
    swipeReveal: "سحبة",
    floatIn: "طفو",
  },
  image: {
    preview: "معاينة الصورة",
  },
  video: {
    preview: "معاينة الفيديو",
    playbackSpeed: "سرعة التشغيل",
    reset: "رجّعها",
    selectSpeed: "اختار السرعة",
    speedNormal: "1x (عادي)",
    speedCustom: "{speed}x (مخصصة)",
  },
  pexels: {
    searchImages: "دوّر على صور...",
    searchVideos: "دوّر على فيديوهات...",
    orientation: "الاتجاه",
    allOrientations: "كل الاتجاهات",
    landscape: "عرضي",
    portrait: "طولي",
    square: "مربع",
    size: "المقاس",
    allSizes: "كل المقاسات",
    small: "صغير",
    medium: "متوسط",
    large: "كبير",
    imagesFound: "لقينا {n} صورة",
    videosFound: "لقينا {n} فيديو",
    page: "صفحة {n}",
    photoBy: "صورة من {name}",
    videoBy: "فيديو من {name}",
    unknown: "مجهول",
    by: "من {name}",
    noImagesFor: "ملقيناش صور لـ \"{query}\"",
    noVideosFor: "ملقيناش فيديوهات لـ \"{query}\"",
    poweredBy: "بدعم من",
    fetchErrorTitle: "حصلت مشكلة",
    fetchErrorBody: "معرفناش نجيب صور أو فيديوهات من Pexels. جرّب تاني بعدين.",
  },
  emptyState: {
    noneAvailable: "مفيش {items} متاحة",
    noResults: "ملقيناش {items}",
    noResultsIn: "ملقيناش {items} في {source}",
    tryAnother: "جرّب كلمة بحث تانية",
    useSearch: "استخدم البحث عشان تلاقي {items}",
    enterTerm: "اكتب اللي بتدوّر عليه فوق",
    mediaTypes: {
      templates: "قوالب",
      videos: "فيديوهات",
      images: "صور",
    },
  },
  localMedia: {
    savedUploads: "الملفات المرفوعة",
    upload: "ارفع",
    uploadMedia: "ارفع ملفات",
    uploadFailed: "الملف مترفعش. جرّب تاني.",
    unsupportedType: "نوع الملف ده مش مدعوم",
    deleteMedia: "امسح الملف",
    all: "الكل",
    images: "صور",
    videos: "فيديوهات",
    audio: "صوت",
    loading: "بنحمّل الملفات...",
    emptyTitle: "مفيش ملفات",
    emptyHint: "ارفع أول ملف عشان تبدأ",
    addToTimeline: "ضيف للتايملاين",
    fileTypes: {
      image: "صورة",
      video: "فيديو",
      audio: "صوت",
    },
  },
  sounds: {
    library: "موسيقى Clip-Short",
    moods: {
      suspense: "تشويق",
      epic: "ملحمية",
      uplifting: "متفائلة",
      calm: "هادية",
      playful: "مرحة",
      emotional: "مؤثرة",
      tech: "تكنولوجيا",
      lofi: "لو-فاي",
      oriental: "شرقي",
      dramatic: "درامية",
    },
    searchTab: "مؤثرات صوتية",
    featuredTab: "موسيقى",
    searchPlaceholder: "دوّر على مؤثرات صوتية…",
    searching: "بندوّر على أصوات...",
    noResults: "ملقيناش أصوات",
    searchPrompt: "دوّر على مؤثر صوتي",
    poweredBy: "بدعم من Freesound.org",
    results: "{n} نتيجة",
    addToTimeline: "ضيف للتايملاين",
    loading: "بنحمّل...",
    loadMore: "اعرض أكتر",
    soundsFrom: "الأصوات من",
    creativeCommons: "(رخصة Creative Commons)",
    musicHint: "مزيكا بتاعتنا، آمنة تنزلها على أي منصة. اختار الإحساس، اسمع التراكات بتاعته، وحط واحد تحت الفيديو كله: بيشتغل واطي تحت الصوت. غيّر علوّه من التايم لاين.",
    putUnder: "حطها تحت الفيديو",
    useInstead: "استخدم دي بدالها",
    underVideo: "تحت الفيديو ده: {mood}",
    removeMusic: "شيلها",
    listen: "اسمع {mood}",
  },
  progressBar: {
    description: "بيتملى مع تشغيل الفيديو، عشان اللي بيتفرج يعرف فاضل قد إيه. مدته هي مدة الطبقة على التايملاين.",
    colour: "اللون",
    colourSwatch: "اللون {color}",
    position: "المكان",
    top: "فوق",
    bottom: "تحت",
    thickness: "السُمك",
    stretch: "مدّه على الفيديو كله",
    add: "شريط التقدّم",
    replace: "غيّر شريط التقدّم",
    addHint: "بيوضح فاضل قد إيه من الفيديو",
  },
};
